// Wohin führt ein Klick auf ein Dokument? (Ticket #428, Björn 25.09.2026)
//
// `dokumente.datei_url` ist kein einheitliches Feld: je nach Herkunft steht dort eine volle
// Adresse, ein Storage-Pfad oder — bei 669 aus Mails abgelegten Dateien — nur die nackte
// Google-Drive-ID ("13-AHCq0CQLuH2sCOBlk9cKLJ0v-JTmQq"). Als <a href> ist so eine ID ein
// RELATIVER Pfad: der Browser ging auf /admin/objekte/<ID>, die Seite kannte kein Objekt
// mit dieser ID und fiel auf die Immobilienliste zurück. Diese Funktion macht daraus immer
// eine absolute Adresse oder sagt ehrlich null.

export interface VerlinkbaresDokument {
  datei_url?: string | null;
  onedrive_url?: string | null;
  gdrive_file_id?: string | null;
}

const ABSOLUT = /^https?:\/\//i;
/** Drive-IDs: 25–60 Zeichen aus Buchstaben, Ziffern, - und _ — kein Schrägstrich, kein Punkt. */
const DRIVE_ID = /^[A-Za-z0-9_-]{25,60}$/;

export function driveAnsicht(fileId: string): string {
  return `https://drive.google.com/file/d/${fileId}/view`;
}

/** Absolute Adresse zum Öffnen, oder null, wenn das Dokument so nicht erreichbar ist. */
export function dokumentOeffnenUrl(d: VerlinkbaresDokument): string | null {
  const url = (d.datei_url || '').trim();
  if (ABSOLUT.test(url)) return url;
  const onedrive = (d.onedrive_url || '').trim();
  if (ABSOLUT.test(onedrive)) return onedrive;
  const driveId = (d.gdrive_file_id || '').trim();
  if (driveId) return driveAnsicht(driveId);
  if (DRIVE_ID.test(url)) return driveAnsicht(url);
  // Storage-Pfad o. Ä.: braucht eine signierte Adresse, die hier nicht gebaut werden kann.
  return null;
}
